module.exports = __webpack_public_path__ + "img/hangzhou.e35aa1ab.png";